import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=368c2223"
import script from "./EventCard.js?vue&type=script&lang=js&external"
export * from "./EventCard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports